<template>
  <DesignPreview
    :preview-urls="line.preview_urls"
    :rounded="roundedCorners"
    edit-button="true" @edit="$emit('edit')"
    class="line-item-preview"
    />
</template>

<style lang="scss" scoped>
.line-item-preview {
  margin: 2em;
}
</style>


<script>
import {isRounded} from "@/lib/productAttrs";
export default {
  props: ['line'],
  data() {
    return {currentIndex: 0}
  },
  computed: {
    currentUrl() {
      return this.line.preview_urls[this.currentIndex];
    },
    roundedCorners() {
      return isRounded(this.line.product);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/LineItemPreview.vue